import { render, staticRenderFns } from "./KETVeranstaltungen.vue?vue&type=template&id=7bb7a8d8&"
import script from "./KETVeranstaltungen.vue?vue&type=script&lang=js&"
export * from "./KETVeranstaltungen.vue?vue&type=script&lang=js&"
import style0 from "./KETVeranstaltungen.vue?vue&type=style&index=0&id=7bb7a8d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports